import slugify from "../utilities/slugify.js";
function cleanPanelContent(container) {
  container.querySelectorAll("p").forEach((p) => {
    const html = p.innerHTML.trim();
    const text = p.textContent.trim();

    const hasMedia = p.querySelector(
      "iframe, video, img, embed, object"
    );

    const isEmpty =
      !text &&
      !hasMedia &&
      html !== "&nbsp;" &&
      html !== "<br>";

    if (isEmpty) {
      p.remove();
    }
  });
}

export default function buildAccordions() {
  console.log("BUILD ACCORDIONS RUNNING");

  const accordions = document.querySelectorAll("[data-accordion]");
  console.log("accordions:", accordions.length);

  accordions.forEach((accordion, accordionIndex) => {
    // ----------------------------------------
    // 🔹 1. STRUCTURED MODE (FAQ, components)
    // ----------------------------------------

    const faqItems = accordion.querySelectorAll(":scope > .sz-faq-item");

    if (faqItems.length) {
      console.log("STRUCTURED ACCORDION MODE (FAQ)");

      faqItems.forEach((faq, itemIndex) => {
        const heading = faq.querySelector(":scope > h2");
        const content = faq.querySelector(":scope > div");

        if (!heading || !content) return;

        const title = heading.textContent.trim();
        const slug = slugify(title);
        const id = slug || `accordion-${accordionIndex}-${itemIndex}`;

        const item = document.createElement("div");
        item.className = "sz-accordion__item";
        item.id = id;

        // heading → button
        heading.classList.add("sz-accordion__heading");
        heading.id = `${id}-heading`;

        const button = document.createElement("button");
        button.className = "sz-accordion__trigger";
        button.setAttribute("data-accordion-toggle", "");
        button.setAttribute("aria-expanded", "false");
        button.setAttribute("aria-controls", `${id}-panel`);

        const labelSpan = document.createElement("span");
        labelSpan.className = "sz-accordion__label";

        while (heading.firstChild) {
          labelSpan.appendChild(heading.firstChild);
        }

        button.appendChild(labelSpan);

        const panel = document.createElement("div");
        panel.className = "sz-accordion__panel";
        panel.id = `${id}-panel`;
        panel.setAttribute("role", "region");
        panel.setAttribute("aria-labelledby", heading.id);
        panel.setAttribute("aria-hidden", "true");

        const inner = document.createElement("div");

        while (content.firstChild) {
          inner.appendChild(content.firstChild);
        }

        cleanPanelContent(inner);

        panel.appendChild(inner);

        // rebuild structure
        heading.innerHTML = "";
        heading.appendChild(button);

        item.appendChild(heading);
        item.appendChild(panel);

        faq.replaceWith(item);
      });

      return; // 🔑 STOP — do not run stream logic
    }

    // ----------------------------------------
    // 🔹 2. EXISTING STREAM MODE (unchanged)
    // ----------------------------------------

    const children = [...accordion.children];

    const hasH2 = children.some((node) => node.tagName === "H2");
    console.log("hasH2:", hasH2);
    if (!hasH2) return;

    let currentItem = null;
    let itemIndex = 0;

    let node = accordion.firstChild;

    while (node) {
      const next = node.nextSibling;

      if (node.nodeType === 1 && node.tagName === "H2") {
        if (currentItem) {
          cleanPanelContent(currentItem);
        }
        itemIndex++;

        const title = node.textContent.trim();
        const slug = slugify(title);
        const id = `${slug || "accordion"}-${accordionIndex}-${itemIndex}`;

        const item = document.createElement("div");
        item.className = "sz-accordion__item";
        item.id = id;

        // reuse H2
        const heading = node;
        heading.classList.add("sz-accordion__heading");
        heading.id = `${id}-heading`;

        const button = document.createElement("button");
        button.className = "sz-accordion__trigger";
        button.setAttribute("data-accordion-toggle", "");
        button.setAttribute("aria-expanded", "false");
        button.setAttribute("aria-controls", `${id}-panel`);

        const labelSpan = document.createElement("span");
        labelSpan.className = "sz-accordion__label";

        // move existing nodes safely
        while (heading.firstChild) {
          labelSpan.appendChild(heading.firstChild);
        }

        // 🔧 remove leading/trailing <br> tags
        while (
          labelSpan.firstChild &&
          labelSpan.firstChild.nodeType === 1 &&
          labelSpan.firstChild.tagName === "BR"
        ) {
          labelSpan.firstChild.remove();
        }

        // remove trailing <br> tags
        while (
          labelSpan.lastChild &&
          labelSpan.lastChild.nodeType === 1 &&
          labelSpan.lastChild.tagName === "BR"
        ) {
          labelSpan.lastChild.remove();
        }

        // unwrap <strong> if it's the only wrapper
        if (
          labelSpan.childNodes.length === 1 &&
          labelSpan.firstChild.nodeType === 1 &&
          labelSpan.firstChild.tagName === "STRONG"
        ) {
          const strong = labelSpan.firstChild;

          while (strong.firstChild) {
            labelSpan.appendChild(strong.firstChild);
          }

          strong.remove();
        }

        button.appendChild(labelSpan);

        const panel = document.createElement("div");
        panel.className = "sz-accordion__panel";
        panel.id = `${id}-panel`;
        panel.setAttribute("role", "region");
        panel.setAttribute("aria-labelledby", heading.id);
        panel.setAttribute("aria-hidden", "true");

        const inner = document.createElement("div");
        panel.appendChild(inner);

        // 🔑 replace first
        accordion.replaceChild(item, node);

        // then build structure
        heading.innerHTML = "";
        heading.appendChild(button);

        item.appendChild(heading);
        item.appendChild(panel);

        currentItem = inner;
      } else if (currentItem && node.nodeType === 1) {
        currentItem.appendChild(node);
      }

      node = next;
    }
    if (currentItem) {
      cleanPanelContent(currentItem);
    }
  });
}
